<template>
  <section>
    <div class="box">
      <el-form :inline="true">
        <el-form-item>
          <el-button type='primary' @click='handleAddChannelType'>新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-select v-model.trim='packageType' filterable placeholder='请选择' style='width: 180px'  @change="packageTypeChange" >
            <el-option value="">全部</el-option>
            <el-option v-for='item in packageTypes' :key='item.value' :label='item.value + " - " + item.label' :value='item.value'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!--    主体内容-->
    <div class="box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 200]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
      <el-table :data='tables' style='width: 100%' stripe :header-cell-style='setTableHeader'>
        <el-table-column prop='id' label='ChannelType'> </el-table-column>
        <el-table-column prop='name' label='名称'> </el-table-column>
        <el-table-column prop="packageType" label="包类型" :formatter="packageTypeFormatter"></el-table-column>
        <el-table-column label='操作' align='right'>
          <template slot-scope='scope'>
            <el-button type='primary' size='mini' @click='handleUpdateChannelType(scope.$index, scope.row)' icon='el-icon-edit' circle></el-button>
            <el-button type='info' size='mini' @click='handleDeletechannelType(scope.row.id, scope.$index)' icon='el-icon-delete' circle></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 200]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <!--逻辑模态框-->
    <el-dialog title='ChannelType管理' :visible='dialogVisible' @close='handleCloseDialog' top='4vh'>
      <el-form :model='form' label-position='right' label-width="120px" :rules='rules' ref='form'>
        <el-form-item label='包类型' prop='packageType'>
          <el-select v-model.trim='form.packageType' filterable placeholder='请选择' style='width: 100%'>
            <el-option v-for='item in packageTypes' :key='item.value' :label='item.value + " - " + item.label' :value='item.value'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='Type' prop='id'>
          <el-input v-model.number='form.id' style='width: 100%'></el-input>
        </el-form-item>
        <el-form-item label='名称' prop='name'>
          <el-input v-model='form.name' style='width: 100%'></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer' style='text-align: left'>
        <el-button type='primary' @click='handleSaveDialog'>保 存</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import api from '@/api/channel'
import options from '@/common/options'

export default {
  name: 'index',
  created () {
    this.fetchData(this.pagesize, this.currentPage)
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    tables () {
      const search = this.search
      if (search) {
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(search) > -1
          })
        })
      }
      return this.tableData
    }
  },
  watch: {
    appId (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData(this.pagesize, this.currentPage)
    }
  },
  data () {
    const TypeValidator = (rule, value, callback) => {
      const packageType = this.form.packageType
      if (!packageType) {
        callback(new Error('请先选择包类型！'))
        return
      }
      if (value === '') {
        callback(new Error('请输入Type'))
      } else if (typeof (value) !== 'number') {
        callback(new Error('请输入数字'))
      } else if (value < 0) {
        callback(new Error('请输入有效数字'))
      } else if (value >= (packageType + 1) * 1000) {
        callback(new Error('Type应小于' + (packageType + 1) * 1000))
      } else if (value <= packageType * 1000) {
        callback(new Error('Type应大于' + packageType * 1000))
      } else {
        callback()
      }
    }
    return {
      pagesize: 20,
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      platformData: {},
      dialogVisible: false,
      packageType: '',
      packageTypes: options.packageTypes,
      search: '',
      form: {
      },
      options: [{
        value: 1,
        label: 'android'
      }, {
        value: 2,
        label: 'ios'
      }],
      AppOptions: [],
      type: false, // 默认状态为新增  true 为修改 false为新增
      index: 0, // 用于修改时保存位置,
      rules: {
        packageType: [{ type: 'number', required: true, message: '请选择包类型', trigger: 'blur' }],
        id: [{ type: 'number', required: true, validator: TypeValidator, trigger: 'blur' }],
        name: [{ type: 'string', required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    fetchData (n1, n2) {
      const params = {
        size: n1,
        page: n2
      }
      if (this.packageType) {
        params.packageType = this.packageType
      }
      api.getChannelTypeDataByPage(params).then(res => {
        this.tableData = res.data
        this.totalCount = res.total
      })
    },
    packageTypeFormatter (row) {
      const packageType = row.packageType
      const item = options.packageTypes.find(item => item.value === packageType)
      if (item) {
        return item.value + '-' + item.label
      }
      return packageType
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.currentPage = 1
      this.fetchData(val, this.currentPage)
    },
    // 显示第几页
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData(this.pagesize, val)
    },
    packageTypeChange (val) {
      this.packageType = val
      this.currentPage = 1
      this.fetchData(this.pagesize, this.currentPage)
    },
    // 新增平台
    handleAddChannelType () {
      this.type = false
      this.form = {}
      this.dialogVisible = true
    },
    // 修改平台
    handleUpdateChannelType (index, rowData) {
      this.type = true
      this.index = index
      const data = Object.assign({}, rowData)
      this.form = data
      this.dialogVisible = true
    },
    // 提交数据 新增 或 修改
    handleSaveDialog () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form)
          const f = this.type ? api.updateChannelType : api.addChannelType
          f(params).then(res => {
            if (this.type) {
              this.tableData.splice(this.index, 1, res)
            } else {
              this.tableData.push(res)
            }
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.dialogVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 删除
    handleDeletechannelType (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteChannelType(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    // 关闭弹窗
    handleCloseDialog () {
      this.dialogVisible = false
      this.$refs.form.clearValidate()
    },
    setTableHeader () {
      return 'color: #000'
    }
  }
}
</script>

<style scoped>
</style>
